import { useState } from "react";

export const SupplierBadge = ({ name, domain, size = "md" }) => {
  const [failed, setFailed] = useState(false);
  const h = size === "sm" ? "h-14" : "h-20";
  return (
    <div data-testid={`supplier-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`${h} bg-white rounded-lg border border-white/10 flex items-center justify-center px-4 hover:scale-[1.03] transition-transform`}>
      {failed ? (
        <span className="font-heading font-bold uppercase tracking-wider text-xs text-slate-700 text-center">{name}</span>
      ) : (
        <img
          src={`https://img.logo.dev/${domain}?token=pk_X-1ZO13GSgeOoUrIuJ6GMQ&size=128&format=png`}
          alt={`${name} logo`}
          className={`${size === "sm" ? "max-h-7" : "max-h-9"} max-w-full object-contain`}
          loading="lazy"
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
};
